export enum DiscountType {
    Amount = 1,
    Percentage = 2,
}